module.exports = __webpack_public_path__ + "img/SCANIA.cb3fc95c.svg";